const tipoEmpresaList = [
    {
        id: 'M',
        descricao: 'MEI - Microempreendedor Individual',
        ordem: 10,
    },
    {
        id: 'U',
        descricao: 'SLU - Sociedade Limitada Unipessoal',
        ordem: 20,
    },
    {
        id: 'L',
        descricao: 'LTDA - Sociedade Limitada',
        ordem: 30,
    },
    {
        id: 'S',
        descricao: 'S/A - Sociedade Anônima',
        ordem: 40,
    },
]

export default tipoEmpresaList
